import { DETERMINAR_PAGINA_ATUAL_VEICULO } from '../types'

export default function determinarPaginaAtualVeiculos (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_VEICULO,
    payload: paginaAtual
  }
}
